"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRandomColor = getRandomColor;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colours = _interopRequireDefault(require("./colours"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]); // https://en.wikipedia.org/wiki/Linear_congruential_generator

function _stringAsciiPRNG(value, m) {
  // Xn+1 = (a * Xn + c) % m
  // 0 < a < m
  // 0 <= c < m
  // 0 <= X0 < m
  var charCodes = Array.from(value).map(function (letter) {
    return letter.charCodeAt(0);
  });
  var len = charCodes.length;
  var a = len % (m - 1) + 1;
  var c = charCodes.reduce(function (current, next) {
    return current + next;
  }) % m;
  var random = charCodes[0] % m;

  for (var i = 0; i < len; i++) {
    random = (a * random + c) % m;
  }

  return random;
}

function defaultInitials(name, options) {
  return name.split(/\s/).map(function (part) {
    return part.substring(0, 1).toUpperCase();
  }).filter(function (v) {
    return !!v;
  }).slice(0, options === null || options === void 0 ? void 0 : options.maxInitials).join('').toUpperCase();
}

function getRandomColor(value, colors) {
  // if no value is passed, always return transparent color otherwise
  // a rerender would show a new color which would will
  // give strange effects when an interface is loading
  // and gets rerendered a few consequent times
  if (!value) return 'transparent'; // value based random color index
  // the reason we don't just use a random number is to make sure that
  // a certain value will always get the same color assigned given
  // a fixed set of colors

  var colorIndex = _stringAsciiPRNG(value, colors.length);

  return colors[colorIndex];
} // eslint-disable-next-line complexity


var Avatar = function Avatar(_ref) {
  var size = _ref.size,
      name = _ref.name,
      src = _ref.src,
      className = _ref.className,
      maxInitials = _ref.maxInitials,
      placeholderUrl = _ref.placeholderUrl,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? true : _ref$rounded,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["size", "name", "src", "className", "maxInitials", "placeholderUrl", "rounded"]);

  var _useState = (0, _react.useState)(!src && name ? 'text' : 'image'),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      displayMode = _useState2[0],
      setDisplayMode = _useState2[1];

  var _useState3 = (0, _react.useState)(src),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      stateSrc = _useState4[0],
      setStateSrc = _useState4[1];

  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme,
    props: {
      size: {
        width: size,
        height: size
      },
      backgroundColor: getRandomColor(name, _colours["default"]),
      rounded: rounded
    }
  });
  (0, _react.useEffect)(function () {
    setDisplayMode(!src && name ? 'text' : 'image');
    setStateSrc(src);
  }, [src, name]);

  var handleOnError = function handleOnError(event) {
    if (event && event.type === 'error') {
      if (name) setDisplayMode('text');else setStateSrc(placeholderUrl);
    }
  };

  if (displayMode === 'image') {
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      className: (0, _classnames["default"])(classes.Avatar, (0, _defineProperty2["default"])({}, classes.Round, rounded), className)
    }, rest), /*#__PURE__*/_react["default"].createElement("img", {
      "data-test-id": "logo",
      className: classes.Image,
      src: stateSrc || placeholderUrl,
      height: size,
      onError: handleOnError,
      alt: name || ''
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])((0, _defineProperty2["default"])({}, classes.Round, rounded), classes.Initials, className)
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.Text, 'text'),
    "data-test-id": "initials"
  }, defaultInitials(name || '', {
    maxInitials: maxInitials
  })));
};

exports["default"] = Avatar;
//# sourceMappingURL=index.js.map